import { IdentifiableOption } from "@/models/models";

export const sortOptions: IdentifiableOption[] = [
  { id: 2, name: "Newest" },
  { id: 3, name: "Oldest" },
  { id: 4, name: "Price - Low to High" },
  { id: 5, name: "Price - High to Low" },
  { id: 6, name: "Sort A to Z" },
  { id: 7, name: "Sort Z to A" },
];
